import React, { useEffect } from "react";
import { EditorContent, useEditor } from "@tiptap/react";
import { notBlank } from "../common/general";
import StarterKit from "@tiptap/starter-kit";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  editor: {
    borderBottomStyle: "solid",
    borderBottomWidth: 1,
    borderBottomColor: "lightgray",
    height: 150,
    overflow: "auto",
    "& p": {
      margin: "10px 0",
    },
  },

  error: {
    borderBottomColor: theme.palette.primary.error,
  },
}));

const RichTextEditor = ({ id, editable, error, html, onBlur, onChange }) => {
  const classes = useStyles();
  const editor = useEditor({
    editorProps: {
      attributes: {
        role: "textbox",
        "aria-labelledby": id,
        "aria-multiline": "true",
        "aria-readonly": "false",
        class: clsx(classes.editor, {
          [classes.error]: Boolean(error),
        }),
      },
    },
    extensions: [StarterKit],
    onUpdate: ({ editor }) => {
      const text = editor.getText();
      const html = editor.getHTML();

      onChange({ text, html });
    },
    onBlur: () => onBlur(),
  });

  useEffect(() => {
    if (editor) {
      if (notBlank(html)) {
        const { from, to } = editor.state.selection;
        // Persist formatting updates and allow whitespaces: https://github.com/ueberdosis/tiptap/issues/2216
        editor.commands.setContent(html, false, {
          preserveWhitespace: "full",
        });

        editor.commands.setTextSelection({ from, to });
      }
    }
  }, [html, editor]);

  useEffect(() => {
    if (editor) {
      editor.setEditable(editable);
    }
  }, [editable, editor]);

  return <EditorContent editor={editor} />;
};

export default RichTextEditor;
